import { render, staticRenderFns } from "./GigBookmarks.htm?vue&type=template&id=1303a051&"
import script from "./GigBookmarks.ts?vue&type=script&lang=js&"
export * from "./GigBookmarks.ts?vue&type=script&lang=js&"
import style0 from "../BookmarksTab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports